module.exports = __webpack_public_path__ + "static/media/admin.60033dd2.svg";